var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-5 text-left row-left" }, [_vm._t("left")], 2),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-2 text-center row-center" },
      [_vm._t("center")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-5 text-right row-right" },
      [_vm._t("right")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }